import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  lista: () => {
    return Vue.http.get('/api/coditemservico').then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/cod-item-servico/servico.js